module.exports = __webpack_public_path__ + "static/assets/c61d0fa03b645b88b1e0e972bb11effd.png";